module.exports = __webpack_public_path__ + "static/media/S2N2-4.8ecaf802.svg";